import React from 'react';
import { StyleSheet, css } from 'aphrodite';

export default function PhoneSection({ children }) {
  return (
    <section className={css(styles.phoneConfirmationSection)}>
      <div className={css(styles.inner)}>
        {children}
      </div>
    </section>);
}

PhoneSection.propTypes = {
  children: React.PropTypes.node,
};

const styles = StyleSheet.create({
  phoneConfirmationSection: {
    padding: '2em 3em',
    backgroundColor: '#F6F5EF',
    lineHeight: '1.4',
    textAlign: 'center',
    flex: '0 1',
    flexBasis: 'calc(390px - 6em)',
  },
  inner: {
    maxWidth: '260px',
    margin: 'auto',
  },
});
